import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

// Deep-linkable dashboard tab: reads ?tab= on mount and whenever the query changes.
export function useTabParam(def) {
  const location = useLocation();
  const [tab, setTab] = useState(() => new URLSearchParams(window.location.search).get("tab") || def);
  useEffect(() => {
    const t = new URLSearchParams(location.search).get("tab");
    if (t) setTab(t);
  }, [location.search]);
  return [tab, setTab];
}

// Exact-record deep link: reads ?focus_type=&focus_id= for opening a specific record.
export function useFocusParam() {
  const location = useLocation();
  return useMemo(() => {
    const p = new URLSearchParams(location.search);
    return { focusType: p.get("focus_type"), focusId: p.get("focus_id") };
  }, [location.search]);
}
